import React, { useState } from "react";
import './sdAddMemo.scss';
import add from "./img/add.png";
import SDInput from "./sdInput";
import SDTimePicker from "./sdTimePicker";
import SDBtn from "./sdBtn";
import { AddDailyCheckList, AddJourney, AddMemorial, AddTodoList, AddUserMC, DeleteUserMC } from "../api";
import SDRadioGroup from "./sdRadioGroup";
import MDatePicker from "./mDatePicker";
import SDCheck from "./sdCheck";
import delIcon from './img/delete.png';

function SDAddMemo (props) {
  const [title, setTitle] = useState('');
  const [showSetting, setShowSetting] = useState(false);
  const [startTime, setStartTime] = useState('00:00');
  const [endTime, setEndTime] = useState('00:00');
  const [mtypeValue, setMTypeValue] = useState(0);
  const [dtypeValue, setDTypeValue] = useState(0);
  const [weekValue, setWeekValue] = useState([]);
  const [startDay, setStartDay] = useState({});
  const [endDay, setEndDay] = useState({});
  const [year, setYear] = useState(props.year);
  const [month, setMonth] = useState(props.month);
  const [day, setDay] = useState(props.day);
  const mtype = ['行程', '待辦事項','紀念日','生日','循環每日確認', '經期紀錄'];
  const mstype = ['行程', '待辦事項','紀念日','生日'];
  const wtype = ['日','一','二','三','四','五','六'];
  const dtype = ['1','2','3','4','5'];//,'三餐飯後','三餐飯後睡前']

  function startShowSetting () {
    setShowSetting(true);
    setWeekValue('');
    setStartDay({});
    setEndDay({});
    setTitle('');
  }

  function clickMask (e) {
    if (e.target.className === 'addmomask') {
      setShowSetting(false);
      return;
    }
  }

  function selectType(e) {
    setMTypeValue(e);
  }

  function selectWeekType (e, d) {
    if (d) {
      let m = [...weekValue, e].sort();
      setWeekValue(m);
    }
    else {
      let m = weekValue.filter(d => d !== e);
      setWeekValue(m);
    }
  }

  function selectStart (e) {
    setStartDay(e);
  }

  function selectEnd (e) {
    setEndDay(e);
  }

  function selectDayType (e) {
    setDTypeValue(e);
  }

  function selectDate (d) {
    setYear(d.year)
    setMonth(d.month)
    setDay(d.day)
  }

  function clickAdd() {
    console.log(mtypeValue);
    
    switch(mtypeValue) {
        case 0:

          if (!title || !year || !day) return;
          let jour = {
            "Index":1,
            "StartYear":year,
            "StartMonth":month,
            "StartDay":day,
            "StartHour":startTime,
            "StartDate":0,
            "EndYear":year,
            "EndMonth":month,
            "EndDay":day,
            "EndHour":endTime,
            "EndDate":0,
            "Title": title,
            "Type":"jour",
            "Color":""
          }

          AddJourney(jour).then(res => {
            console.log(res);
          })
          break;
        case 1: 
          if (!title || !year || !day) return;
          let todo = {
            "Year": year,
            "Month": month,
            "Day": day,
            "Title": title,
            "Checked": false
          };

          AddTodoList(todo).then(res => {
            console.log(res);
          });
        break;
        case 2:
          if (!title || !year || !day) return;
          let me = {
            "Year": year,
            "Month": month,
            "Day": day,
            "Title": title,
            "Type": "m"
          }

          AddMemorial(me).then(res => {
            console.log(res);
          })

          break;
        case 3:
          if (!title || !year || !day) return;
          let bir = {
            "Year": year,
            "Month": month,
            "Day": day,
            "Title": title,
            "Type": "b"
          }

          AddMemorial(bir).then(res => {
            console.log(res);
          })

          break;
        case 4: 
          if (!title || !startDay || !endDay) return;

          let cycle = 
            {
              "Week": weekValue.join(''),
              "StartYear": startDay.year,
              "StartMonth": startDay.month,
              "StartDay": startDay.day, 
              "EndYear": endDay.year,
              "EndMonth": endDay.month,
              "EndDay": endDay.day,
              "Title": title,
              "DayTimes": dtypeValue.toString()
          }

          AddDailyCheckList(cycle).then(res => {
            console.log(res);
          })

          console.log(cycle);
        break;
        case 5:
          console.log(`${year}-${month}-${day}`)
          if (!year || !day) return;
          let mc = {
            "Year": year,
            "Month": month,
            "Day": day,
          }

          AddUserMC(mc).then(res => {
            
          })
          break;
        default:
          break;
      }
    setShowSetting(false);
  }

  function deleteMC(d) {
    DeleteUserMC({
      data: {
      UserMCID: d.userMCID,
      year: d.year,
      month: d.month,
      day: d.day}
    }).then(res => console.log(res));
  }

  return (<div className="addMemo">
    <div className="plusicon" style={{backgroundImage: `url(${add})`}}
    onClick={() => startShowSetting()}></div>
    {
      showSetting ? <div className="addmomask" onClick={e => clickMask(e)}>
        <div className="settingBlock">
          <div>
          { props.inputDate ? 
            <SDRadioGroup label={'類別'} value={mtypeValue} data={mtype} onSelect={e => selectType(e)}></SDRadioGroup> :
            <SDRadioGroup label={'類別'} value={mtypeValue} data={mstype} onSelect={e => selectType(e)}></SDRadioGroup> }
          </div>
          { mtypeValue !== 4 ? props.inputDate ? 
            <div><MDatePicker label={"日期"} selectDate={e => selectDate(e)}></MDatePicker></div> : 
            <div className="memodate">日期:{`${year}-${month + 1}-${day}`}</div>
            : ''
          }
          { mtypeValue !== 5 ?
          <div className="memotopic"><SDInput change={setTitle} label="標題"></SDInput></div> : ''
          }
          { mtypeValue === 0 ?
            <div>
              <SDTimePicker changeTime={setStartTime} label={"開始時間"}></SDTimePicker>
              <SDTimePicker changeTime={setEndTime} label={"結束時間"}></SDTimePicker>
              <div className="memotip">※若開始時間大於結束時間，則會計算至隔日</div>
            </div> : ''
          }
          { mtypeValue === 4 ?
            <div className="dailyCycle">
              <div className="dailyRange">
              <MDatePicker label={"執行期間"} selectDate={e => selectStart(e)}></MDatePicker>
              <div>~</div>
              <MDatePicker selectDate={e => selectEnd(e)}></MDatePicker>
              </div>
              <div className="dailyWeek">
                <div>週重複：</div>
                {
                  wtype.map((d, i) => {
                    return <SDCheck key={d} changeState={(e, d) => selectWeekType(e, d)} label={d} data={i} type=""></SDCheck>;
                  })
                }
              </div>
              <div className="">
              <SDRadioGroup label={'日次數'} value={dtypeValue} data={dtype} onSelect={e => selectDayType(e)}></SDRadioGroup>
              </div>
            </div> : ''
          }
          {
            mtypeValue === 5 ? 
            <div className="mcTable">
              <div className="mcTitle">近四次紀錄</div>
            {
              props.mcHistory.map(d => {
                return <div className="mcData" key={d.userMCID}>
                  <div>{`${d.year}-${d.month + 1}-${d.day}`}</div>
                  <div><div className="deleteMC" style={{backgroundImage: `url(${delIcon})`}}
                        onClick={() => deleteMC(d)}></div></div>
                  </div>
              })
            }
            </div>
            : ''
          }
          <div className="memoSubmit"><SDBtn label="添加" click={() => clickAdd()} ></SDBtn></div>
        </div>
      </div> : ''
    }
  </div>);
}

export default SDAddMemo;

